<script>
import config from './../../config';
import axios from 'axios';
import utils from './../../utils';
export default {
    name: 'ViewModalPesquisa',
    data: () => ({
        rules: [
            value => !!value || 'Obligatorio.',
            value => (value && value.length >= 3) || 'Min 3 characters',
        ],
        filterData: '',
        result: '',
        urlBase: window.location.origin,
        tableModalShow: false,
        disabledButton: true,
    }),
    methods: {
        close() {

            this.result = '';
            this.tableModalShow = !this.tableModalShow;
            this.filterData = ''
            this.$emit('close');
        },
        async buscaDadosWebService() {

            this.disabledButton = !this.disabledButton
            this.tableModalShow = false

            let teste = [];

            //Pedidos
            await axios.get(`${config.VUE_APP_API_URL}venusa/order_all`, {
                params: {
                    filterByColumnName: { "SALES_ORDER": this.filterData },
                    UNIDADE_PAIS: utils.loadCountry(),
                    USERID: utils.loadUserId(),
                    CUSTOMER: this.customerCode,
                    TOKEN: utils.loadToken()
                }
            })
                .then(({ data }) => {
                    data.lista.map(list => {
                        teste.push({ type: 'pedido' + ' - ' + list.SALES_ORDER, url: this.urlBase + '/#/orders/' + list.SALES_ORDER })
                    })
                });

            //Faturas
            await axios.get(`${config.VUE_APP_API_URL}venusa/faturamento`, {
                params: {
                    UNIDADE_PAIS: utils.loadCountry(),
                    USERID: utils.loadUserId(),
                    filterByColumnName: { "TRANSACTION_NUMBER": this.filterData },
                    TOKEN: utils.loadToken()
                }
            })
                .then(({ data }) => {
                    data.lista.map(list => {
                        teste.push({ type: 'fatura' + ' - ' + list.INVOICE, url: this.urlBase + '/#/facturacion/' + list.INVOICE })
                    })
                });

            // //Itens Pendentes
            await axios.get(`${config.VUE_APP_API_URL}venusa/order_pending`, {
                params: {
                    UNIDADE_PAIS: utils.loadCountry(),
                    USERID: utils.loadUserId(),
                    filterByColumnName: { "SALES_ORDER": this.filterData },
                    TOKEN: utils.loadToken()
                }
            })
                .then(({ data }) => {
                    data.lista.map(list => {
                        teste.push({ type: 'item pendente' + ' - ' + list.SALES_ORDER, url: this.urlBase + '/#/orders/' + list.SALES_ORDER })
                    })
                });

            this.result = teste

            this.result.forEach((indice, valor) => {
                console.log(indice, valor, indice.url)
            });

            this.tableModalShow = true
            this.disabledButton = !this.disabledButton
            // this.close();
        }
    },
};
</script>

<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <slot name="header">
                        Dado para busca
                    </slot>
                    <button type="button" class="btn-close" @click="close">
                        x
                    </button>
                </header>

                <section class="modal-body" id="modalDescription">
                    <div style="margin-bottom: 30px;">
                        <v-text-field label="Dado para busca" :rules="rules" hide-details="auto"
                            v-model="filterData"></v-text-field>
                    </div>
                    <v-btn elevation="2" @click="buscaDadosWebService()" :disabled="!disabledButton" >Buscar</v-btn>
                </section>
                <section class="modal-footer" style="text-align: center; align-tems:center;">
                    <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        v-if="!disabledButton"
                    ></v-progress-circular>
                    </div>
                    <template v-if="tableModalShow">
                        <v-card class="mx-auto">
                            <v-list subheader two-line>
                                <v-list-item v-for="item in result" :key="item.type">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.type"></v-list-item-title>
                                    </v-list-item-content>

                                    <a :href="item.url" @click="$event => close()">
                                        <v-list-item-action>
                                            <v-btn icon>
                                                <v-icon color="grey lighten-1">mdi-link-variant</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </a>
                                </v-list-item>

                                <v-divider inset></v-divider>
                            </v-list>
                        </v-card>
                    </template>
                </section>
            </div>
        </div>
    </transition>
</template>

<style>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 8;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 60%;
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: normal;
    font-family: Roboto, sans-serif !important;
    font-size: 0.85em;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    color: rgba(0, 0, 0, 0.54) !important;
    font-weight: normal;
    font-family: Roboto, sans-serif !important;
    font-size: 0.85em;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
}

.btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>